/* KleenKick V3 — FAQ accordion (tap to expand) */
(function () {
  'use strict';

  document.querySelectorAll('[data-kk-faq]').forEach((item) => {
    const btn = item.querySelector('.kk-faq-item__btn');
    if (!btn) return;

    btn.addEventListener('click', () => {
      const isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      // Optional: close others (uncomment for single-open accordion)
      // if (isOpen) {
      //   document.querySelectorAll('[data-kk-faq].is-open').forEach((other) => {
      //     if (other !== item) other.classList.remove('is-open');
      //   });
      // }
    });
  });
})();
